var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("v-row", [
    _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          "flex-direction": "row",
          "flex-grow": "1",
          "align-items": "stretch",
          "flex-wrap": "wrap"
        }
      },
      [
        _c(
          "v-col",
          {
            attrs: {
              cols: "12",
              sm: "6"
            }
          },
          [
            _c(
              "gg-card",
              {
                staticStyle: {
                  height: "100%"
                }
              },
              [
                _c(
                  "gg-card-text",
                  {
                    staticClass: "pa-3"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "body-1 mb-5"
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "pb-1 pl-2",
                            attrs: {
                              size: "24",
                              color: "primary"
                            }
                          },
                          [_vm._v("mdi-account-card-details")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "ml-2 font-weight-medium"
                          },
                          [_vm._v("Server Information")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      {
                        staticClass: "pb-3 pl-2 pr-2"
                      },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "pb-0 font-bold",
                            attrs: {
                              cols: "2"
                            }
                          },
                          [_vm._v("Username:")]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "pb-0 text-right",
                            attrs: {
                              cols: "10"
                            }
                          },
                          [
                            _vm._v(" " + _vm._s(_vm.accountData.user) + " "),
                            _c(
                              "gg-btn",
                              {
                                staticClass: "ml-1",
                                attrs: {
                                  icon: ""
                                },
                                on: {
                                  click: function click($event) {
                                    return _vm.copyToClipboard(
                                      _vm.accountData.user
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      small: ""
                                    }
                                  },
                                  [_vm._v("mdi-content-copy")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "pb-0 pt-0 font-bold",
                            attrs: {
                              cols: "2"
                            }
                          },
                          [_vm._v("Hostname:")]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "pb-0 pt-0 text-right",
                            attrs: {
                              cols: "10"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.accountData.server_hostname) +
                                " "
                            ),
                            _c(
                              "gg-btn",
                              {
                                staticClass: "ml-1",
                                attrs: {
                                  icon: ""
                                },
                                on: {
                                  click: function click($event) {
                                    return _vm.copyToClipboard(
                                      _vm.accountData.server_hostname
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      small: ""
                                    }
                                  },
                                  [_vm._v("mdi-content-copy")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "pb-0 pt-0 font-bold",
                            attrs: {
                              cols: "2"
                            }
                          },
                          [_vm._v("IP:")]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "pb-0 pt-0 text-right",
                            attrs: {
                              cols: "10"
                            }
                          },
                          [
                            _vm._v(" " + _vm._s(_vm.accountData.ip) + " "),
                            _c(
                              "gg-btn",
                              {
                                staticClass: "ml-1",
                                attrs: {
                                  icon: ""
                                },
                                on: {
                                  click: function click($event) {
                                    return _vm.copyToClipboard(
                                      _vm.accountData.ip
                                    )
                                  }
                                }
                              },
                              [
                                _c(
                                  "v-icon",
                                  {
                                    attrs: {
                                      small: ""
                                    }
                                  },
                                  [_vm._v("mdi-content-copy")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _c(
          "v-col",
          {
            attrs: {
              cols: "12",
              sm: "6"
            }
          },
          [
            _c(
              "gg-card",
              {
                staticStyle: {
                  height: "100%"
                }
              },
              [
                _c(
                  "gg-card-text",
                  {
                    staticClass: "pa-3"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "body-1 mb-5"
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            staticClass: "pb-1 pl-2",
                            attrs: {
                              size: "24",
                              color: "primary"
                            }
                          },
                          [_vm._v("mdi-mixcloud")]
                        ),
                        _c(
                          "span",
                          {
                            staticClass: "ml-2 font-weight-medium"
                          },
                          [_vm._v("Domain Nameservers")]
                        )
                      ],
                      1
                    ),
                    _c(
                      "v-row",
                      {
                        staticClass: "pb-3 pl-2 pr-2"
                      },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "pb-0",
                            attrs: {
                              cols: "12"
                            }
                          },
                          [_vm._v("ns1.greengeeks.net")]
                        ),
                        _c(
                          "v-col",
                          {
                            staticClass: "pb-0 pt-1",
                            attrs: {
                              cols: "12"
                            }
                          },
                          [_vm._v("ns2.greengeeks.net")]
                        ),
                        _vm.isResellerService
                          ? _c(
                              "v-col",
                              {
                                staticClass: "pb-0",
                                attrs: {
                                  cols: "12"
                                }
                              },
                              [
                                _c(
                                  "gg-btn",
                                  {
                                    staticClass: "mr-1",
                                    attrs: {
                                      secondary: ""
                                    },
                                    on: {
                                      click: function click($event) {
                                        return _vm.goToKnowledgebase()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(" Use Custom Nameservers "),
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "pl-2",
                                        attrs: {
                                          small: ""
                                        }
                                      },
                                      [_vm._v("mdi-open-in-new")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        ),
        _vm.isResellerSubAccount && !_vm.isResellerMainAccount
          ? _c(
              "v-col",
              {
                attrs: {
                  cols: "12",
                  sm: "6"
                }
              },
              [
                _c(
                  "gg-card",
                  [
                    _c(
                      "gg-card-text",
                      {
                        staticClass: "pa-3"
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "body-1 mb-5"
                          },
                          [
                            _c(
                              "v-icon",
                              {
                                staticClass: "pb-1",
                                attrs: {
                                  size: "24",
                                  color: "primary"
                                }
                              },
                              [_vm._v("mdi-lock")]
                            ),
                            _c(
                              "span",
                              {
                                staticClass: "ml-2"
                              },
                              [_vm._v("Password Management")]
                            )
                          ],
                          1
                        ),
                        _c(
                          "div",
                          [
                            _c(
                              "router-link",
                              {
                                staticClass: "ma-0 font-bold",
                                attrs: {
                                  to: _vm.changePasswordRoute
                                }
                              },
                              [_vm._v(" Change Password ")]
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }